import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    resolveMaintenanceWarningEvents,
    reset
} from './redux/slice';
const ConfirmResolveMaintenanceWarningEvent = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { openModal, loading, data, result, error } = useSelector(state => state.confirmResolveMaintenanceWarningEventsRedux)

    const closeModal = () => {
        dispatch(reset())
    }

    const applyChanges = () => {
        dispatch(resolveMaintenanceWarningEvents(data))
    }

    useEffect(() => {
        if (result) {
            let title = data?.bulk ? messages['maintenance_warnings_tab_resolve_all_warnings'] : messages['maintenance_warnings_tab_resolve_warning']
            let successMessage = data?.bulk ? messages['maintenance_warnings_tab_success_message_all'] : messages['maintenance_warnings_tab_success_message']
            let errorMessage = data?.bulk ? messages['maintenance_warnings_tab_error_message_all'] : messages['maintenance_warnings_tab_error_message']
            if (result?.resolve) {
                NotificationManager.success(successMessage, title, 3000);
                closeModal()
            } else {
                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            let title = data?.bulk ? messages['maintenance_warnings_tab_resolve_all_warnings'] : messages['maintenance_warnings_tab_resolve_warning']
            let errorMessage = data?.bulk ? messages['maintenance_warnings_tab_error_message_all'] : messages['maintenance_warnings_tab_error_message']
            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    return (
        <Modal
            open={openModal}
            title={data?.bulk ? messages['maintenance_warnings_tab_resolve_all_warnings'] : `${messages['maintenance_warnings_tab_resolve_warning']} (${data?.warning})`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    {
                        data?.bulk ? <p>{messages['maintenance_warnings_tab_description_all']}</p> : <p>{messages['maintenance_warnings_tab_description']}</p>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_close']}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['maintenance_warnings_tab_resolve']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmResolveMaintenanceWarningEvent;